import axiosService from '@services/axiosService';

export const transcriptEntryRoutePrefix = '/api/TranscriptEntries';

export const getTransciptEntryById = ({ id, isAIRoute }, token, otp) => {
  const params = {
    access_token: token,
    otp,
  };
  return axiosService.get(
    `${transcriptEntryRoutePrefix}/${id}/${
      isAIRoute ? 'full-ai-transcript' : 'full-transcript'
    }`,
    { params },
  );
};

export const resubmitTranscriptEntry = (id, token) => {
  const params = {
    access_token: token,
  };
  return axiosService.post(
    `${transcriptEntryRoutePrefix}/${id}/request-manual-transcript`,
    {},
    { params },
  );
};

export const changeSpeakerNamesInTranscript = ({ transcriptId, speakers }, token) => {
  return axiosService.post(
    `${transcriptEntryRoutePrefix}/${transcriptId}/change-speakers?access_token=${token}`,
    { ...speakers },
  );
};

export const getRecordingsLinks = (id, token) => {
  const params = {
    access_token: token,
  };

  return axiosService.get(`${transcriptEntryRoutePrefix}/${id}/recordingsLinks`, {
    params,
  });
};



// WEBPACK FOOTER //
// ./services/transcriptEntryResource.js